/** A referential list of status filters: no tenant, no parameter. */
class FetchWorkflowRunStatusFilters {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchWorkflowRunStatusFilters;
